import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Seo from '@/components/feature/Seo';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import HeroAndHot from '@/pages/home/components/HeroAndHot';
import FeedAndCats from '@/pages/home/components/FeedAndCats';
import ReversalAndFaq from '@/pages/home/components/ReversalAndFaq';
import { faqs } from '@/mocks/faq';
import { articles } from '@/mocks/articles';
import { canonicalUrl } from '@/utils/helpers';

const og = (articles.find((a) => a.featured) || articles[0]).cover;

export default function Home() {
  const [showTop, setShowTop] = useState(false);
  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const origin = window.location.origin;
  const siteUrl = origin + (__BASE_PATH__ || '');
  const schema = [
    { '@context': 'https://schema.org', '@type': 'Organization', name: '每日大瓜', url: siteUrl, description: '全网吃瓜时间线，瓜中瓜连环反转全程追踪。', sameAs: [] },
    { '@context': 'https://schema.org', '@type': 'WebSite', name: '每日大瓜', url: siteUrl, inLanguage: 'zh-CN', publisher: { '@type': 'Organization', name: '每日大瓜' } },
    { '@context': 'https://schema.org', '@type': 'WebPage', name: '每日大瓜 · 全网吃瓜时间线', url: canonicalUrl(), inLanguage: 'zh-CN', isPartOf: { '@type': 'WebSite', url: siteUrl } },
    { '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: faqs.map((f) => ({ '@type': 'Question', name: f.q, acceptedAnswer: { '@type': 'Answer', text: f.a } })) },
  ];

  return (
    <>
      <Seo
        title="每日大瓜 | 全网吃瓜时间线 · 瓜中瓜连环反转全程追踪"
        description="每日大瓜为你整理全网吃瓜时间线，瓜中瓜连环反转全程追踪。当事人回应打脸、录音文件流出、聊天记录截图，关键证据一应俱全，帮你理清每场大戏的来龙去脉。"
        keywords="每日大瓜,全网吃瓜时间线,瓜中瓜反转,当事人打脸,录音文件流出,聊天记录截图"
        image={og}
        jsonLd={schema}
      />
      <SiteHeader logoHeading />

      <main>
        <HeroAndHot />
        <FeedAndCats />
        <ReversalAndFaq />

        {/* CTA */}
        <section className="mx-auto w-full max-w-6xl px-4 md:px-6 py-10 md:py-14">
          <div className="relative overflow-hidden rounded-lg bg-background-950 px-6 py-10 md:p-12">
            <div className="pointer-events-none absolute -right-10 -top-10 h-48 w-48 rounded-full bg-primary-500/20 blur-2xl" />
            <div className="pointer-events-none absolute -bottom-12 left-1/3 h-40 w-40 rounded-full bg-accent-500/20 blur-2xl" />
            <div className="relative flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
              <div className="max-w-xl">
                <h3 className="text-xl md:text-2xl font-bold text-background-50">追不动了？让每日大瓜帮你把每场大戏捋明白</h3>
                <p className="mt-2 text-sm leading-relaxed text-background-300">
                  事件还原、反转追踪、证据梳理三管齐下。四大栏目持续更新，从影视星闻到圈内动态，全网热瓜一个不漏。
                </p>
              </div>
              <div className="flex flex-wrap gap-3">
                <Link to="/about" className="inline-flex items-center whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-primary-600">
                  了解我们 <i className="ri-arrow-right-line ml-1.5" aria-hidden="true" />
                </Link>
                <Link to="/category/quannei" className="inline-flex items-center whitespace-nowrap rounded-md border border-background-200 px-5 py-2.5 text-sm font-semibold text-background-100 transition hover:bg-background-50 hover:text-foreground-950">
                  去瓜田逛逛
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>

      <SiteFooter />

      {showTop && (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg shadow-primary-500/25 transition hover:bg-primary-600"
          aria-label="回到顶部"
        >
          <i className="ri-arrow-up-line text-lg" aria-hidden="true" />
        </button>
      )}
    </>
  );
}